import { withCompInfo } from '@wix/editor-elements-integrations'
import type { WFacebookCommentCSSVars, WFacebookCommentDefinition } from './WFacebookComment'

export const css = withCompInfo<WFacebookCommentCSSVars | {}, WFacebookCommentDefinition>()(
	['hasResponsiveLayout', 'compLayout', 'isOneDocMigrated'],
	({ hasResponsiveLayout, compLayout, isOneDocMigrated }) => {
		return !hasResponsiveLayout && !isOneDocMigrated
			? {
				height: 'auto',
				'min-height': `${compLayout.height}px`,
			}
			: {}
	}
)
